var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_2719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_2719)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#D92D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 6.42315L12.7421 6.42315L12.7421 13.1731L11.2422 13.1731L11.2422 6.42315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 15.1169C11.5715 14.9621 11.7633 14.8846 11.9921 14.8846C12.221 14.8846 12.4128 14.9621 12.5676 15.1169C12.7224 15.2717 12.7998 15.4635 12.7998 15.6923C12.7998 15.9212 12.7224 16.113 12.5676 16.2678C12.4128 16.4226 12.221 16.5 11.9921 16.5C11.7633 16.5 11.5715 16.4226 11.4167 16.2678C11.2619 16.113 11.1845 15.9212 11.1845 15.6923C11.1845 15.4635 11.2619 15.2717 11.4167 15.1169Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.609d4883a4a5d2b989d357ae04b2e3a5.svg";
export { ForwardRef as ReactComponent };